module.exports = __webpack_public_path__ + "assets/fonts/6607769b7c3cb6405d68c8cc0e70287c.woff";